<template>
  <div class="modal-card">
    <div class="modal-card-head" style="justify-content: center">
      <b-field>
        <LanguagePicker
          v-model="lang.lang1"
          class="control min-width-300"
          :blacklist="[lang.lang2]"
          :change-local="false"
          :loading="false"
          :disabled="!editable"
        />
        <p class="control">
          <b-button
            class=""
            :disabled="!editable"
            :icon-left="lang.mono ? 'arrow-right-bold' : 'arrow-left-right-bold'"
            @click="lang.mono = !lang.mono"
          />
        </p>
        <LanguagePicker
          v-model="lang.lang2"
          class="control min-width-300"
          :blacklist="[lang.lang1]"
          :change-local="false"
          :loading="false"
          :disabled="!editable"
        />
      </b-field>
    </div>
    <div class="modal-card-body">
      <b-message class="is-primary">
        {{ $t("biMonoDirectionalExplained") }}
        <br /><br />
        <b>{{ $t("monodirectional") }}:</b>
        {{ $t("monodirectionalExplained") }}
        <br /><br />
        <b>{{ $t("bidirectional") }}:</b>
        {{ $t("bidirectionalExplained") }}
      </b-message>
      <b-field>
        <b-radio-button
          v-model="lang.mono"
          :native-value="true"
          type="is-primary"
          class="control"
          :disabled="!editable"
        >
          <b-icon icon="arrow-right" />
          <span>{{ $t("monodirectional") }}</span>
        </b-radio-button>
        <b-radio-button
          v-model="lang.mono"
          :native-value="false"
          type="is-primary"
          class="control"
          :disabled="!editable"
        >
          <b-icon icon="arrow-left-right" />
          <span>{{ $t("bidirectional") }}</span>
        </b-radio-button>
      </b-field>

      <!-- <b-message class="is-primary">
        {{ $t("timedExplained") }}
        <br /><br />
        <b>{{ $t("timing") }}:</b>
        {{ $t("timedExplained") }}
      </b-message>
      <b-field>
        <b-radio-button
          v-model="lang.timed"
          :native-value="true"
          type="is-primary"
          :disabled="!editable"
        >
          <b-icon icon="timer-outline" />
          <span>{{ $t("timed") }}</span>
        </b-radio-button>

        <b-radio-button
          v-model="lang.timed"
          :native-value="false"
          type="is-primary"
          :disabled="!editable"
        >
          <b-icon icon="timer-off-outline" />
          <span>{{ $t("timedOff") }}</span>
        </b-radio-button>
      </b-field>
      <div class="mb-4">
        <div v-if="lang.timed">
          <div v-if="selectableDates.length > 0">
            <b-message class="is-primary">
              {{ $t("selectTranslatorDays") }}
            </b-message>
            <b-datepicker
              v-model="selectedDates"
              :selectable-dates="editable ? selectableDates : [new Date(0)]"
              multiple
              inline
              icon="calendar-today"
              :events="selectableDates"
              :first-day-of-week="1"
              :locale="`${$i18n.locale}-${$i18n.locale.toUpperCase()}`"
              @input="inputDateRange"
            >
              <template>
                <div class="is-clearfix">
                  <div style="color:#818181" class="is-pulled-right">
                    {{ $t("timezone") }}:
                    {{ Intl.DateTimeFormat().resolvedOptions().timeZone }}
                  </div>
                </div>
              </template>
            </b-datepicker>
            <div
              v-for="day in selectedDates"
              :key="moment(day).format('YYYY-MM-DD')"
              class="card mb-4 mt-4"
            >
              <div class="card-content">
                <b-message class="is-primary">
                  {{ $t("selectTranslatorTimeslots") }}
                </b-message>
                <b-field
                  :label="
                    $t(`days[${day.getDay()}]`) +
                      ' ' +
                      new Intl.DateTimeFormat('de-DE').format(day)
                  "
                />
                <b-field
                  v-for="timeslot in lang.timeslots.filter(
                    y =>
                      moment(y.startTime).format('YYYY-MM-DD') ===
                      moment(day).format('YYYY-MM-DD')
                  )"
                  :key="timeslot._sortId"
                  group-multiline
                  grouped
                  class="mb-4"
                >
                  <b-field class="pr-4" :label="$t('translationStartTime')">
                    TODO: Look into bug on timeslots "mintime" of starttime
                    <b-timepicker
                      v-model="timeslot.startTime"
                      :min-time="
                        editable
                          ? eventTimes[
                              selectableDates
                                .map(y => moment(y).format('YYYY-MM-DD'))
                                .indexOf(moment(day).format('YYYY-MM-DD'))
                            ].startTime
                          : timeslot.startTime
                      "
                      :max-time="
                        editable
                          ? eventTimes[
                              selectableDates
                                .map(y => moment(y).format('YYYY-MM-DD'))
                                .indexOf(moment(day).format('YYYY-MM-DD'))
                            ].endTime
                          : timeslot.startTime
                      "
                      :increment-minutes="15"
                      type="is-primary"
                      inline
                      hour-format="24"
                    />
                    <template slot="message">
                      <div class="is-clearfix">
                        <div style="color:#818181" class="is-pulled-right">
                          {{ $t("timezone") }}:
                          {{ Intl.DateTimeFormat().resolvedOptions().timeZone }}
                        </div>
                      </div>
                    </template>
                  </b-field>
                  <b-field class="pr-4" :label="$t('translationEndTime')">
                    <b-timepicker
                      v-model="timeslot.endTime"
                      :increment-minutes="15"
                      inline
                      type="is-primary"
                      :min-time="
                        editable ? timeslot.startTime : timeslot.endTime
                      "
                      :max-time="
                        editable
                          ? eventTimes[
                              selectableDates
                                .map(y => moment(y).format('YYYY-MM-DD'))
                                .indexOf(moment(day).format('YYYY-MM-DD'))
                            ].endTime
                          : timeslot.endTime
                      "
                    />
                    <template slot="message">
                      <div class="is-clearfix">
                        <div style="color:#818181" class="is-pulled-right">
                          {{ $t("timezone") }}:
                          {{ Intl.DateTimeFormat().resolvedOptions().timeZone }}
                        </div>
                      </div>
                    </template>
                  </b-field>
                  <b-field :label="'\xa0'">
                    <b-button
                      v-if="editable"
                      class="is-medium mt-2"
                      icon-left="delete"
                      type="is-danger"
                      @click="deleteTimeslot(timeslot._sortId)"
                    />
                  </b-field>
                </b-field>
                <b-field>
                  <b-button
                    v-if="editable"
                    class="is-primary"
                    icon-left="plus"
                    @click="addTimeslot(day)"
                  >
                    {{ $t("addTimeslot") }}
                  </b-button>
                </b-field>
              </div>
            </div>
          </div>
          <div v-else>
            <b-message type="is-warning">
              {{ $t("selectAtLeast1Date") }}
            </b-message>
          </div>
        </div>
      </div> -->
      <b-field :label="$t('translation')" />
      <b-message class="is-primary">
        {{ $t("translationExplained") }}
      </b-message>
      <b-field>
        <div>
          <b-field grouped group-multiline>
            <b-radio-button
              v-model="activeTab"
              native-value="0"
              type="is-primary"
              :disabled="!editable"
              @click.native="disableEmails"
            >
              <span :class="activeTab == 0 ? 'has-text-weight-bold' : ''">{{ $t("qondaTranslations") }}</span>
              <b-icon v-if="activeTab == 0" class="ml-2" icon="check" />
            </b-radio-button>

            <b-radio-button
              v-model="activeTab"
              native-value="1"
              type="is-primary"
              :disabled="!editable"
              @click.native="initEmails"
            >
              <span :class="activeTab == 1 ? 'has-text-weight-bold' : ''">{{ $t("ownTranslations") }}</span>
              <b-icon v-if="activeTab == 1" class="ml-2" icon="check" />
            </b-radio-button>

            <!--<b-radio-button
              v-model="activeTab"
              native-lang="2"
              type="is-primary"
              icon-left="check"
            >
              <span :class="activeTab == 2 ? 'has-text-weight-bold' : ''">{{ $t('3. option') }}</span>
              <b-icon
                v-if="activeTab == 2"
                class="ml-2"
                icon="check" 
              />
            </b-radio-button>-->
          </b-field>

          <div>
            <div v-if="activeTab == 0">
              <b-message class="is-primary">
                {{ $t("qondaTranslationsExplained") }}
              </b-message>
            </div>
            <div v-else-if="activeTab == 1">
              <b-message class="is-primary">
                {{ $t("ownTranslationsExplained") }}
              </b-message>
              <b-field :label="$t('addEmails')" />
              <div v-for="(email, key) in translatorEmails" :key="key" class="mb-3">
                <b-field :type="email.mail != '' ? '' : 'is-warning'">
                  <b-input
                    v-model.lazy="email.mail"
                    :readonly="!editable"
                    :placeholder="$t('email')"
                    type="email"
                    icon="email"
                  />
                </b-field>
              </div>
              <b-field v-if="editable" grouped group-multiline>
                <b-button icon-left="plus" class="is-primary control" @click="addEmail" />
                <b-button icon-left="delete" class="is-danger" @click="removeEmail" />
              </b-field>
            </div>
            <div v-else>
              <b-message class="is-primary"> something here??? </b-message>
            </div>
          </div>
        </div>
      </b-field>
    </div>
    <footer class="modal-card-foot">
      <b-button v-if="closable" type="is-primary" @click="validateDate">
        {{ $t("close") }}
      </b-button>
      <b-tooltip v-else class="is-warning" position="is-right" :label="$t('selectAtLeast1Timeslot')">
        <b-button type="is-warning" disabled>
          {{ $t("close") }}
        </b-button>
      </b-tooltip>
    </footer>
  </div>
</template>

<script>
import LanguagePicker from "@/components/LanguagePicker";
import moment from "moment";
import { v4 } from "uuid";
import Vue from "vue";

export default {
  name: "TranslationWizardModal",
  components: {
    LanguagePicker,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    langWhiteList: {
      type: Array,
      default: null,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeTab: "0",
      selectedDates: [],
      translatorEmails: [],
      moment,
    };
  },
  computed: {
    lang: {
      get() {
        return Vue.observable(this.value);
      },
      set(value) {
        this.value = Vue.observable(value);
      },
    },
    selectableDates() {
      return this.eventTimes.map((y) => y.date);
    },
    eventTimes() {
      return this.$store.state.draft.eventTimes;
    },
    closable() {
      return !(this.lang.timed && this.selectedDates.length == 0);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (
          JSON.stringify(this.translatorEmails) !=
          JSON.stringify(
            this.lang.translatorEmails.map((y) => {
              return { mail: y };
            }),
          )
        ) {
          this.translatorEmails = this.lang.translatorEmails.map((y) => {
            return { mail: y };
          });
        }
      },
    },
    lang: {
      deep: true,
      handler() {
        this.value = Vue.observable(this.lang);
      },
    },
    translatorEmails: {
      deep: true,
      handler(translatorEmails) {
        this.lang.translatorEmails = translatorEmails.map((y) => y.mail);
      },
    },
  },
  mounted() {
    // update selectedDates List, Set so as to remove duplicates
    let dates = this.eventTimes.map((y) => moment(y.date).format("YYYY-MM-DD"));
    let newSelectedDates = [...new Set(this.lang.timeslots.map((y) => moment(y.startTime).format("YYYY-MM-DD")))]
      .filter((y) => dates.includes(y))
      .map((y) => moment(y).toDate());
    newSelectedDates.forEach((y) => {
      this.selectedDates.push(y);
    });
    this.selectedDates = this.selectedDates.sort((a, b) =>
      moment(a).format("YYYY-MM-DD").localeCompare(moment(b).format("YYYY-MM-DD")),
    );

    // calculate chosen Translator option

    if (this.lang.da24 === false) {
      this.activeTab = "1";
    } else {
      this.activeTab = "0";
    }
  },
  methods: {
    // remove impossible timeslots, i.e those that on days which are not selected in the Duration Component and are therefor not in eventTimes
    validateDate() {
      let timeslotDays = this.lang.timeslots.map((y) => moment(y.startTime).format("YYYY-MM-DD"));
      let eventDays = this.eventTimes.map((y) => moment(y.date).format("YYYY-MM-DD"));
      let removedTimeslots = timeslotDays.filter((y) => !eventDays.includes(y));
      this.lang.timeslots = this.lang.timeslots.filter(
        (y) => !removedTimeslots.includes(moment(y.startTime).format("YYYY-MM-DD")),
      );
      this.$parent.close();
    },
    inputDateRange(avDates) {
      // format list of dates
      let dates = this.lang.timeslots.map((y) => moment(y.startTime).format("YYYY-MM-DD"));
      let newDates = avDates.filter((y) => !dates.includes(moment(y).format("YYYY-MM-DD")));

      if (newDates.length > 0) {
        newDates.forEach((day) => {
          this.addTimeslot(day);
        });
      } else {
        let formattedAvDates = avDates.map((y) => moment(y).format("YYYY-MM-DD"));
        let removedDates = dates.filter((y) => !formattedAvDates.includes(y));
        this.selectedDates = this.selectedDates.filter((y) => !removedDates.includes(moment(y).format("YYYY-MM-DD")));
        this.lang.timeslots = this.lang.timeslots.filter(
          (y) => !removedDates.includes(moment(y.startTime).format("YYYY-MM-DD")),
        );
      }
      this.selectedDates = this.selectedDates.sort((a, b) =>
        moment(a).format("YYYY-MM-DD").localeCompare(moment(b).format("YYYY-MM-DD")),
      );
    },
    addTimeslot(day) {
      let limit =
        this.eventTimes[
          this.selectableDates.map((y) => moment(y).format("YYYY-MM-DD")).indexOf(moment(day).format("YYYY-MM-DD"))
        ];
      this.lang.timeslots.push({
        startTime: this.setTime(day, limit.startTime.getHours(), limit.startTime.getMinutes()),
        endTime: this.setTime(day, limit.endTime.getHours(), limit.endTime.getMinutes()),
        _sortId: v4(),
      });
    },
    deleteTimeslot(sortId) {
      let index = this.lang.timeslots.findIndex((t) => t._sortId == sortId);
      let day = moment(this.lang.timeslots[index].startTime).format("YYYY-MM-DD");
      this.$delete(this.lang.timeslots, index);
      if (this.lang.timeslots.filter((y) => moment(y.startTime).format("YYYY-MM-DD") == day).length == 0) {
        this.addTimeslot(day);
      }
    },
    initEmails() {
      this.lang.da24 = false;
      if (!this.translatorEmails) {
        this.translatorEmails = [{ mail: "" }];
      }
    },
    disableEmails() {
      this.lang.da24 = true;
      if (this.translatorEmails) {
        this.translatorEmails = undefined;
      }
    },
    addEmail() {
      this.translatorEmails.push({ mail: "" });
    },
    removeEmail() {
      this.translatorEmails.splice(this.translatorEmails.length - 1, 1);
      if (this.translatorEmails.length < 1) {
        this.addEmail();
      }
    },
    setTime(date, hour, minute = 0, second = 0, millisecond = 0) {
      let time = moment(date).toDate();

      time.setMilliseconds(millisecond);
      time.setSeconds(second);
      time.setMinutes(minute);
      time.setHours(hour);

      return new Date(time);
    },
  },
};
</script>

<style>
.min-width-300 .dropdown-content {
  min-width: 300px;
}

.timepicker {
  min-width: 200px;
}
</style>
